module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/pc/contacts/img_about02-9c0c2b478f3809cd91c298323f76a3e0.jpg";